const EventCalendar = {
    initCheckboxes: function (selector) {
        const $checkboxes = $(selector);

        $checkboxes.on("change", function () {
            EventCalendar.toggleCheckbox(this);
            this.form.submit();
        });

        $checkboxes.each(function (i, checkbox) {
            const mark = document.createElement("span");
            mark.classList.add("checkmark");
            mark.innerHTML = `<i class="fa fa-check"></i>`;
            mark.addEventListener("click", function() {
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new CustomEvent("change"));
            });

            $(checkbox).parents(".checkbox").prepend(mark);

            if (checkbox.checked) EventCalendar.toggleCheckbox(checkbox);
        });
    },
    toggleCheckbox: function (checkbox) {
        $(checkbox).parents(".checkbox").toggleClass("checked");
    },
};
